import { render } from "./TopBannerSection.vue?vue&type=template&id=ef31b842"
import script from "./TopBannerSection.vue?vue&type=script&lang=js"
export * from "./TopBannerSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__